import { render } from "./Photocopy.vue?vue&type=template&id=5e5c975b&scoped=true"
import script from "./Photocopy.vue?vue&type=script&lang=js"
export * from "./Photocopy.vue?vue&type=script&lang=js"

import "./Photocopy.vue?vue&type=style&index=0&id=5e5c975b&scoped=true&lang=css"

import exportComponent from "/home/sfj/repos/digital-photocopier-wasm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e5c975b"]])

export default __exports__